import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_APP005_Request,
  IAPI_APP005_Response,
  IAPI_APP006_Request,
  IAPI_APP006_Response,
} from "../../../type/apiType";

// 共済契約対象施設への復帰情報参照
const httpAPI_APP005 = async (
  param: IAPI_APP005_Request
): Promise<IAPI_APP005_Response> => {
  const res = await http.post(ApiUrl.API_APP005, { ...param });

  return res.data;
};

// 共済契約対象施設への復帰情報更新
const httpAPI_APP006 = async (
  param: IAPI_APP006_Request
): Promise<IAPI_APP006_Response> => {
  let res = await http.post(ApiUrl.API_APP006, {
    ...param,
  });

  return res.data;
};

export { httpAPI_APP005, httpAPI_APP006 };
